import { createContext } from "react";

const AppContext = createContext();
const UserContext = createContext();

export { UserContext, AppContext };
